export default "__VITE_ASSET__DCTBYz_T__"